<div class="keyboard-container">
  <ul *ngFor="let row of layout" style="list-style-type: none;">
    <li *ngFor="let line of row.row" class="btn" [ngClass]="getKeyCssClass(line)" (click)="liClicked(line)"
      [attr.disabled]="isDisabled(line) ? true : null">
      {{ line.value | translate }}
    </li>
  </ul>
</div>
